<template>
  <div class="container">
    <van-cell
      class="header"
      :title="title"
      title-class="name"
      :value="`${gtv}元`"
      value-class="gtv"
    />
    <long-list
      :api-method="getActivityDayPoiGTVFlow"
    >
      <template #default="{list}">
        <van-cell>
          <div
            v-if="list && list.length > 0"
            class="row title"
          >
            <span class="item">时间</span>
            <span class="item">类型</span>
            <span class="item">金额</span>
          </div>
        </van-cell>
        <van-cell
          v-for="(item,index) in list"
          :key="index"
        >
          <div class="row">
            <span class="item">{{ item.time | timeFilter }}</span>
            <span class="item">{{ item.type | typeFilter }}</span>
            <span class="item">{{ item.amount }}元</span>
          </div>
        </van-cell>
      </template>
    </long-list>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { Sticky } from 'vant';
import ActivityApi from '@/api/activity';
import LongList from '@/components/LongList';
import { getDayGTVFlowDesc } from '@/constants/activity';
import { formatTimestamp } from '@/util/filter';

export default {
  name: 'DayBillDetail',
  components: {
    LongList,
    [Sticky.name]: Sticky,
  },
  filters: {
    timeFilter(time) {
      return formatTimestamp(time, 'hh:mm');
    },
    typeFilter(type) {
      return getDayGTVFlowDesc(type);
    },
  },
  computed: {
    title() {
      const day = this.$route.query.day || '';
      return dayjs(`${day}`).format('MM月DD日GTV');
    },
    gtv() {
      return this.$route.query.gtv;
    },
  },
  methods: {
    async getActivityDayPoiGTVFlow(pageNum, pageSize) {
      const {
        customerId, activityId, day, poiId, billMonth,
      } = this.$route.query;
      const res = await ActivityApi.getActivityDayPoiGTVFlow(customerId, activityId, day, poiId, billMonth, pageNum, pageSize);
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
  .header {
    border-bottom: 0.02rem solid #969799;
    .name{
      font-weight: bold;
      font-size: 0.35rem;
      color: black;
      text-align: left;
    }
    .gtv {
      @extend .name;
      text-align: right;
    }
  }
  .row {
    display: flex;
    background-color: white;
    .item {
      text-align: center;
      flex: 1;
    }

    &.title {
      font-weight: bold;
    }
  }
</style>
